export default __webpack_public_path__ + "static/char-s-30-zh-Hant-153657d8800694f490a30ce4e9dc37bd.png";